// extracted by mini-css-extract-plugin
module.exports = {"bgLogo":"CompanyDetail_bgLogo__2CApL","logo":"CompanyDetail_logo__1sIL4"};